<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
	<footer class="the-footer flex-wrap justify-between" :class="classes">
		<span>&copy; {{ new Date().getFullYear() }} <a href="https://sangiaodich.comayplus.com" target="_blank" rel="nofollow">Agri Index</a></span>

		<!-- buyNow component -->
	</footer>
</template>

<script>
export default {
	name: "the-footer",
	props: {
		classes: {
			type: String
		}
	},
	inject: {
		components: {
			default: {}
		}
	}
};
</script>
